@for (children of childrenList; track $index) {
  @if (!children.hidden) {
    <div [ngStyle]="{'padding-left': (16*this.level) + 'px'}">
      <div class="common-branch-tree__col-item-container">
        @if((children.concepts?.length || children.children?.length || children.subFolders?.length) && !children.disabledChildren){
          <button class="common-button__icon-sm-noborder"
            (click)="changeShow(children)">
            <i class="common-icon__md"
              [ngClass]="children.show?'lf-icon-angle-up':'lf-icon-angle-down'"></i>
          </button>
        }@else {
          <div class="common-branch-tree__space-button-sm"></div>
        }
        <div class="common-button__block-button-md-checkbox">
          <button class="common-button__icon-md-checkbox"
            [ngClass]="{'common-button__icon-md-checkbox--selected': children.selected}"
            [disabled]="children.disabled || (children.concepts?.length && branchTree.product === 2)"
            (click)="selectItem(children)">
            <i class="common-icon__md"
              [ngClass]="children.selected?'lf-icon-radio-button-active':'lf-icon-step-first'"></i>
          </button>
        </div>
        <div class="common-branch-tree__item-container"
          [ngClass]="{'common-branch-tree__item-container--disabled': children.disabled || (children.concepts?.length && branchTree.product === 2)}">
          <div class="common-icon__md"
            [ngClass]="{'lf-icon-svg-folder-md': !children.isFront && !children.hidden && !children.show,
              'lf-icon-svg-folder-user-md': children.isFront && !children.hidden && !children.show,
              'lf-icon-svg-folder-open-md':children.show}"></div>
          <span>{{children.name}}</span>
        </div>
      </div>
    </div>
    @for (concept of children.concepts; track $index) {
      @if (!concept.hidden && children.show) {
        <div [ngStyle]="{'padding-left': (16*this.branchTree.nextLevel) + 'px'}">
          <div class="common-branch-tree__col-item-container">
            <div class="common-branch-tree__space-button-sm"></div>
            <div class="common-button__block-button-md-checkbox">
              <button class="common-button__icon-md-checkbox"
                [disabled]="true">
                <i class="lf-icon-step-first common-icon__md"></i>
              </button>
            </div>
            <div class="common-branch-tree__item-container common-branch-tree__item-container--disabled">
              <i class="common-icon__md"
                [ngClass]="{'lf-icon-template': !concept.isFront,
                'lf-icon-template-user': concept.isFront}">
              </i>
              <span>{{concept.title}}</span>
            </div>
          </div>
        </div>
      }
    }
    @if (children.show) {
      <branch-tree class="common-branch-tree__container-children"
        [childrenList]="children[branchTree.typeChildren]"
        [product]="branchTree.product"
        [type]="type"
        [level]="branchTree.nextLevel"
        (selectChildrenEmit)="selectChildrenTree($event)">
      </branch-tree>
    }
  }
}
